import { FormattedMessage, IntlContextConsumer, changeLocale, useIntl } from 'gatsby-plugin-intl';
import React, { FC } from 'react';

import { ROUTER_PATHS } from '@constants/router';
import IFoodFooter from 'images/footer/logo.svg';
import { Languages, LanguagesFields } from 'modules/Core/types';

import { LANGUAGES_OPTIONS } from '../../constants';
import { Container, Content, Copyright, CopyrightText, FooterLink, Icon, SelectLanguages } from './styles';

const yearFormatting = {
  year: new Date().getFullYear(),
};

const Footer: FC = () => {
  const { formatMessage } = useIntl();

  const languageValues = React.useMemo(
    () =>
      LANGUAGES_OPTIONS.map((value) => ({
        value,
        name: formatMessage({ id: `core.footer.languages.${value}` }),
      })),
    [LANGUAGES_OPTIONS]
  );

  return (
    <Container>
      <Content>
        <Copyright>
          <FooterLink noMargin dataTestId="footer-back-to-home" href={ROUTER_PATHS.HOME}>
            <Icon src={IFoodFooter} alt="" />
          </FooterLink>
          <CopyrightText>
            <FormattedMessage id="core.footer.legal.copyright-notice" values={yearFormatting} />
          </CopyrightText>
        </Copyright>
        <IntlContextConsumer>
          {({ language: currentLocale }: { language: Languages }): JSX.Element => (
            <SelectLanguages
              name={LanguagesFields.language}
              items={languageValues}
              value={{
                value: currentLocale,
                name: formatMessage({ id: `core.footer.languages.${currentLocale}` }),
              }}
              onChange={(e): void => {
                if (e.currentTarget.value !== currentLocale) {
                  changeLocale(e.currentTarget.value);
                }
              }}
            />
          )}
        </IntlContextConsumer>
      </Content>
    </Container>
  );
};

export default Footer;
